<script>

    import Common from "../../Common";
    import {createEventDispatcher} from "svelte";


    const dispatch = createEventDispatcher();

    export let rent;

    let address = {};

    export function initialize() {
        debugger
        address = {
            phone: rent.phone
        };
    }

    function save() {
        console.log(address);
        if (Common.isEmpty(address.name)) {
            Common.error("Pole 'Nazwa / Imię i Nazwisko' nie może być puste");
            return;
        }
        Common.addAddress(rent.uuid, address).then(function (response) {
            Common.info("Adres został zapisany. Możesz go teraz użyć do generacji faktury.");
            dispatch('save', {});
        });
    }

</script>

<div class="flex flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-8 lg:py-12 px-4">
    <div class="w-1/4 text-center flex flex-col justify-center items-center">
        <i class="fa fa-plus fa-3x blue-2"></i>
    </div>
    <div class="w-3/4 text-center justify-center flex flex-col">
        <span class="text-2xl mt-4">
            <span>Podaj nowe dane do faktury</span>
        </span>
    </div>
</div>

<div class="flex flex-col lg:flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-8 lg:py-12 px-4">
    <div class="w-full lg:w-1/4 text-center flex flex-reverse-col justify-center items-center mb-1 lg:mb-0">
        <span class="text-2xl">
            <span>Nazwa / Imię i Nazwisko</span>
        </span>
    </div>
    <div class="w-full lg:w-1/4 text-center justify-center flex flex-col">
        <input type="text" class="text-3xl rounded text-black p-1 text-center"
               bind:value={address.name}/>
    </div>
</div>
<div class="flex flex-col lg:flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-8 lg:py-12 px-4">
    <div class="w-full lg:w-1/4 text-center flex flex-reverse-col justify-center items-center mb-1 lg:mb-0">
        <span class="text-2xl">
            <span>Ulica i nr budynku</span>
        </span>
    </div>
    <div class="w-full lg:w-1/4 text-center justify-center flex flex-col">
        <input type="text" class="text-3xl rounded text-black p-1 text-center"
               bind:value={address.address}/>
    </div>
</div>
<div class="flex flex-col lg:flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-8 lg:py-12 px-4">
    <div class="w-full lg:w-1/4 text-center flex flex-reverse-col justify-center items-center mb-1 lg:mb-0">
        <span class="text-2xl">
            <span>Kod pocztowy</span>
        </span>
    </div>
    <div class="w-full lg:w-1/4 text-center justify-center flex flex-col">
        <input type="text" class="text-3xl rounded text-black p-1 text-center"
               bind:value={address.postalCode}/>
    </div>
</div>
<div class="flex flex-col lg:flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-8 lg:py-12 px-4">
    <div class="w-full lg:w-1/4 text-center flex flex-reverse-col justify-center items-center mb-1 lg:mb-0">
        <span class="text-2xl">
            <span>Miejscowość</span>
        </span>
    </div>
    <div class="w-full lg:w-1/4 text-center justify-center flex flex-col">
        <input type="text" class="text-3xl rounded text-black p-1 text-center"
               bind:value={address.city}/>
    </div>
</div>
<div class="flex flex-col lg:flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-8 lg:py-12 px-4">
    <div class="w-full lg:w-1/4 text-center flex flex-reverse-col justify-center items-center mb-1 lg:mb-0">
        <span class="text-2xl">
            <span>NIP</span>
        </span>
    </div>
    <div class="w-full lg:w-1/4 text-center justify-center flex flex-col">
        <input type="text" class="text-3xl rounded text-black p-1 text-center"
               bind:value={address.nip}/>
    </div>
</div>
<div class="flex flex-col lg:flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-8 lg:py-12 px-4">
    <div class="w-full lg:w-1/4 text-center flex flex-reverse-col justify-center items-center mb-1 lg:mb-0">
        <span class="text-2xl">
            <span>Adres e-mail</span>
        </span>
    </div>
    <div class="w-full lg:w-1/4 text-center justify-center flex flex-col">
        <input type="text" class="text-3xl rounded text-black p-1 text-center"
               bind:value={address.mail}/>
    </div>
</div>
<div class="flex flex-col lg:flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-8 lg:py-12 px-4">
    <div class="w-full lg:w-1/4 text-center flex flex-reverse-col justify-center items-center mb-1 lg:mb-0">
        <span class="text-2xl">
        <span>Nr telefonu</span>
        </span>
    </div>
    <div class="w-full lg:w-1/4 text-center justify-center flex flex-col">
        <input type="text" class="text-3xl rounded text-black p-1 text-center"
               bind:value={address.phone}/>
    </div>
</div>
<div class="flex flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-8 lg:py-12 px-4" on:click={save}>
    <div class="w-full text-center justify-center flex flex-col">
        <span class="text-2xl">
            <i class="fa fa-check blue-2"></i>
            <span class="ml-2">Zapisz</span>
        </span>
    </div>
</div>